export const onImageError = (event: any) =>
  ((event.target as any).style.opacity = '0');
